import { useTranslation } from 'react-i18next';
import SingleValueTile from '../tiles/SingleValueTile/SingleValueTile';
import ReportingDashboardSection, {
    SectionItem,
    SectionProps,
} from './ReportingDashboardSection';
import { formatIntShort } from '../../../../../utils/formatters';
import { useSelector } from '../../../../../store/hooks';
import { GridItemSpans } from '../../../../../controls/ResponsiveGrid/ResponsiveGridItem';

const itemSpans: GridItemSpans = {
    tabletSpan: 6,
} as const;

const GeneralSection: React.FC<SectionProps> = ({ className }) => {
    const { t } = useTranslation();

    const { previousRange, currentRange } = useSelector(
        (x) => x.reportingDashboard
    );

    return previousRange && currentRange ? (
        <ReportingDashboardSection className={className}>
            <>
                <SectionItem {...itemSpans}>
                    <SingleValueTile
                        title={t('ReportingDashboard_CheckIns')}
                        previousValue={previousRange.checkInCount}
                        currentValue={currentRange.checkInCount}
                        formatter={formatIntShort}
                        showTooltip
                    />
                </SectionItem>
                <SectionItem {...itemSpans}>
                    <SingleValueTile
                        title={t('ReportingDashboard_Conversations')}
                        previousValue={previousRange.conversationCount}
                        currentValue={currentRange.conversationCount}
                        formatter={formatIntShort}
                        showTooltip
                    />
                </SectionItem>
            </>
        </ReportingDashboardSection>
    ) : null;
};

export default GeneralSection;
